// GENERATED FILE - DO NOT MODIFY

export enum SortDirectionDto {
    Ascending = "Ascending",
    Descending = "Descending",
}